import { ProductInformation } from '../../types/Products/product';
import { request } from '../../utils/request';

type ResType = {
  data: Array<ProductInformation>;
  pagination: any;
};

export const getAllProducts = (
  authToken: string,
  store_id: number,
  page?: number,
  filter?: Record<string, string>
): Promise<ResType> => {
  const params = new URLSearchParams({
    store_id: `${store_id}`,
    page: `${page ?? 1}`,
    limit: '10',
    ...filter,
  });

  return request({
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    method: 'GET',
    url: `/products/me?${params.toString()}`,
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
